import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ProjectView from "@/pages/ProjectView";
import Catalog from "@/pages/Catalog";
import CatalogDetail from "@/pages/CatalogDetail";
import Pricing from "@/pages/Pricing";
import PitchDeck from "@/pages/PitchDeck";
import Branding from "@/pages/Branding";
import SharedPlan from "@/pages/SharedPlan";
import Settings from "@/pages/Settings";
import AdminUsers from "@/pages/AdminUsers";
import LandingPlayground from "@/pages/landing-variants/LandingPlayground";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

function HomeGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return <LandingPlayground />;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/catalog/:slug" element={<CatalogDetail />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/share/plans/:token" element={<SharedPlan />} />
            <Route path="/" element={<HomeGate />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id"
              element={
                <ProtectedRoute>
                  <ProjectView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/pitch-deck"
              element={
                <ProtectedRoute>
                  <PitchDeck />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/branding"
              element={
                <ProtectedRoute>
                  <Branding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/branding"
              element={
                <ProtectedRoute>
                  <Branding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
